import axios from 'axios';
function loadOurDomainScriptCode(isDevEnv, domainName, apiKey, userEmail) {

    var urlPath = window.location.pathname;
    var isHomePage = urlPath.includes("/home") || urlPath == "/";
    if (isHomePage && (typeof loadTrack != "undefined" && loadTrack == false)) {
        console.warn("loadTrack is not defined or false, skipping OurDomainScriptCode loading.");
        return;
    }

    //Login Svg Static
    var $loader = document.getElementById('login-img-static');
    if ($loader)
        $loader.addEventListener('load', function () {
            $loader.style.background = "none";
        }, true);

    if (isDevEnv) {
        return;
    }

    function inIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0)
                return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function pushTageNameToOurDomain(apiKey, userEmail) {

        var type = "POST";
        var data = {};
        data["apiKey"] = apiKey;
        data.email = userEmail;
        data.tags = ehAPItagName;

        var query_string = "";
        // Iterate json
        for (var key in data) {
            var value = data[key];
            if (value && typeof value != "string")
                continue;
            query_string += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
        }

        var url = "https://our.engagebay.com/jsapi/rest/add-tag";

        // Create a new XMLHttpRequest object and set Authorization, Accept and Content-type headers.
        var request = new XMLHttpRequest();
        request.open(type, url, true);
        // request.setRequestHeader("Authorization", EhAccount.getKey());
        request.setRequestHeader("Accept", "application/json");

        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                var response = this.response;
                if (response)
                    response = JSON.parse(response);
                console.log(response);
            } else {
                console.log(this.response);
            }
        }
        if (type == "POST" || type == "PUT") {
            request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            request.send(query_string);
        } else {
            request.send();
        }

    }

    window.EhAPI = window.EhAPI || {};
    console.log("window.EhAPI", window.EhAPI);

    function installOurDomainCode() {
        try {
            window.engagebayPushWebEvent = engagebayPushWebEvent;
        } catch (error) {
            console.error("Error setting engagebayPushWebEvent", error);
        }
        EhAPI.after_load = function () {
            EhAPI.set_account(apiKey, domainName);

            // Set tracking domain
            if (domainName && domainName.toLowerCase() === "our") {
                EhAPI.push(['setTrackDomain', 'engagebay.com']);
            }

            // Set email
            if (userEmail && userEmail !== "") {
                if(CURRENT_USER_JSON && CURRENT_USER_JSON.is_owner)
                    EhAccount.setEmail(userEmail, {});
                else
                    EhAPI.push(['setEmail', userEmail]);
            }

            EhAPI.execute('rules');

            function setLCPrefs() {
                var prefs = localStorage.getItem("engagebay-form_data");
                if (!prefs)
                    prefs = {};

                try {
                    prefs = JSON.parse(prefs);
                } catch (e) {
                }

                if (!prefs.name)
                    prefs.name = CURRENT_USER_JSON.name;

                if (!prefs.email)
                    prefs.email = CURRENT_USER_JSON.email;

                localStorage.setItem("engagebay-form_data", JSON.stringify(prefs));

                // Set reacho prefs
                window._reachoOnsite = window._reachoOnsite || [];
                window._reachoOnsite.push(["identify", { "name": CURRENT_USER_JSON.name }]);
                window._reachoOnsite.push(["identify", { "email": CURRENT_USER_JSON.email }]);
            }

            // Set email for livechat
            try {
                setLCPrefs();
            } catch (e) {
            }

        };
        (function (d, s, f) {
            var sc = document.createElement(s);
            sc.type = 'text/javascript';
            sc.async = true;
            sc.src = f;
            var m = document.getElementsByTagName(s)[0];
            m.parentNode.insertBefore(sc, m);
        })(document, 'script', '//d2p078bqz5urf7.cloudfront.net/jsapi/ehform.js?v1_' + new Date().getHours());

        /*   (function (d, s, f) {
               var sc = document.createElement(s);
               sc.type = 'text/javascript';
               sc.async = true;
               sc.src = f;
               var m = document.getElementsByTagName(s)[0];
               m.parentNode.insertBefore(sc, m);
           })(document, 'script', '//site-tracking.reacho.com/onsite/js/reacho.js?company_id=66fac33fb1c6dc08789b4d39');*/
    }

    var ehAPItagName = "";

    if (inIframe() && readCookie("_DISABLE_ENGAGEBAY_BRANDING")) {
        if (ehAPItagName) {
            pushTageNameToOurDomain();
        }
    } else {
        installOurDomainCode();
    }

    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
            'gtm.start':
                new Date().getTime(), event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-5SGZ3ZH');

    function engagebayPushWebEvent(eventCode) {
        var eventData = {
            domainID: CURRENT_DOMAIN_JSON.id,
            domainName: CURRENT_DOMAIN_JSON.name,
            userId: CURRENT_USER_JSON.email,
        };

        if (eventCode == "billing_page_seen" || eventCode == "recent_login")
            eventData.platform = "webapp";

        EbTrackAPI.getInstance(function (tracker) {
            tracker.pushEvent(eventCode, $.extend({ time: new Date().getTime(), pageUrl: window.location.href }, eventData));
        });

        /*EhAPI.push(["pushEvent", {
            event: eventCode,
            payload: $.extend({ time: new Date().getTime(), pageUrl: window.location.href }, eventData)
        }]);*/
    }

    setTimeout(function () {
        if (window.CURRENT_DOMAIN_JSON && fireLoginEvenTrigger && (parseInt(new Date().getTime() / 1000) - CURRENT_DOMAIN_JSON.created_time) > 3600)
            engagebayPushWebEvent("recent_login");
    }, 5000);

}

const checkAndLoadOurDomainScript = (isDevEnv, isResellerClient, resellerID, email, isOwner) => {
    const isRecent = window.CURRENT_DOMAIN_JSON.created_time > (Math.floor(Date.now() / 1000) - 600);
    if (isRecent && isOwner && !resellerID) {
        fetchContactDetailsFromOurDomain(email).then(response => {
            if (response.isFound) {
                injectOurDomainScriptCode(isDevEnv, isResellerClient, resellerID, email);
            } else {
                setTimeout(() => checkAndLoadOurDomainScript(isDevEnv, isResellerClient, resellerID, email, isOwner), 10000);
            }
        }).catch(error => {
            console.error("Failed to fetch contact details", error);
            setTimeout(() => checkAndLoadOurDomainScript(isDevEnv, isResellerClient, resellerID, email, isOwner), 10000);
        });
    } else {
        injectOurDomainScriptCode(isDevEnv, isResellerClient, resellerID, email);
    }
};

const fetchContactDetailsFromOurDomain = (email) => {
    return axios.get(`/rest/api/jsp-dependencies/is-user-created?email=${email}`)
        .then(response => response.data)
        .catch(() => ({ isFound: false }));
};

const injectOurDomainScriptCode = (isDevEnv, isResellerClient, resellerID, email) => {

    let apiKey = "ktb76s1540fl2hnhbqnrtd2npb";
    let domainName = "our";

    if (resellerID && Number(resellerID) > 0) {

        // axios call to get the domain name and api key
        axios.get('/rest/api/jsp-dependencies/get-reseller-apikey-dependencies?id=' + resellerID)
            .then(response => {

                domainName = response.data.domainName;
                apiKey = response.data.apiKey;

                loadOurDomainScriptCode(false, domainName, apiKey, email);
            })
            .catch(error => {
                console.error('Error fetching domain and API key:', error);
            });

    } else {
        loadOurDomainScriptCode(false, domainName, apiKey, email);
    }

}

const OurDomainScriptModule = {
    injectOurDomainScriptCode,
    checkAndLoadOurDomainScript
};

export default OurDomainScriptModule;
